import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = "h-4 w-4", showValue = false, count }) => {
  const rounded = Math.round(value);
  return (
    <div className="flex items-center gap-1" data-testid="stars">
      <div className="flex">
        {[1, 2, 3, 4, 5].map((i) => (
          <Star
            key={i}
            className={`${size} ${i <= rounded ? "fill-amber-400 text-amber-400" : "fill-slate-200 text-slate-200"}`}
          />
        ))}
      </div>
      {showValue && value > 0 && (
        <span className="text-sm font-bold text-navy">{value.toFixed(1)}</span>
      )}
      {typeof count === "number" && count > 0 && (
        <span className="text-xs text-muted-foreground">({count})</span>
      )}
    </div>
  );
};

export const StarInput = ({ value, onChange }) => (
  <div className="flex gap-1" data-testid="star-input">
    {[1, 2, 3, 4, 5].map((i) => (
      <button
        key={i}
        type="button"
        onClick={() => onChange(i)}
        data-testid={`star-${i}`}
        className="p-0.5"
      >
        <Star className={`h-6 w-6 ${i <= value ? "fill-amber-400 text-amber-400" : "fill-slate-200 text-slate-200"}`} />
      </button>
    ))}
  </div>
);
